module.exports = __webpack_public_path__ + "static/media/personal-JS.9795a646.PNG";